<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Estrutura</mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                <mat-form-field fxFlexOffset="20px" fxFlex="80%">
                    <input #descricao matInput maxlength="100" [(ngModel)]="estruturaUnidade.descricao" name="descricao"
                        placeholder="Descrição:">
                    <mat-hint align="end">{{descricao.value.length}} / 100</mat-hint>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                    <input [(ngModel)]="estruturaUnidade.quantidade" type="number" min=0 matInput
                        name="quantidadeMaterial" placeholder="Quantidade:" />
                </mat-form-field>

            </div>

            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                    fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>

                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                    fxFlex="20%" color="primary" (click)="atualizar()">
                    Atualizar
                </button>

            </div>


        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Estrutura ( {{listaEstruturaUnidade?.length}} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="descricao">
                    <th mat-header-cell *matHeaderCellDef> Descrição </th>
                    <td mat-cell *matCellDef="let element"> {{element.descricao}} </td>
                </ng-container>

                <ng-container matColumnDef="quantidade">
                    <th mat-header-cell *matHeaderCellDef> Quantidade </th>
                    <td mat-cell *matCellDef="let element"> {{element.quantidade}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button mat-button (click)="atualizarCentrosDeCusto(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar nova conta" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</form>